import React, { useContext } from 'react'

import { modalContext } from 'global/context/sub-contexts/modalContext'
import { userContext } from 'global/context/sub-contexts/userContext'

import { Formik, Field } from 'formik'
import { updateProfile } from 'services/user'
import { renderTextInput } from 'components/forms/SharedInputs'

const ChangeFunFactForm = () => {
  const modal_context = useContext(modalContext)
  const user_context = useContext(userContext)

  const { toggleModal } = modal_context || {}

  const handleChangeFunFact = newFunFact => {
    updateProfile({ funFact: newFunFact }).then(function (response) {
      if (response.success && response.detail.user) {
        user_context.setProfile(response.detail.user)
        toggleModal('off')
      } else {
        console.log('problem updating user fun fact')
      }
    })
  }

  return (
    <Formik
      initialValues={{
        newFunFact: '',
      }}
      validateOnBlur={true}
      validateOnChange={true}
      onSubmit={values => {
        handleChangeFunFact(values.newFunFact)
      }}
    >
      {({ values, handleSubmit, setFieldValue, errors, touched }) => {
        return (
          <div className="modal-fun-fact">
            <div className="modal-header">
              <span className="modal-header-expiry"></span>
            </div>
            <div className="content-body">
              <form onSubmit={handleSubmit} id="changeFunFact">
                <ul className="form__elements" style={{ padding: '4px' }}>
                  <li className="form__element">
                    <Field
                      name="newFunFact"
                      type="text"
                      label="New Fun Fact"
                      placeholder={'New Fun Fact'}
                      component={renderTextInput}
                      error={errors.newFunFact}
                      touched={touched.newFunFact && true}
                    />
                  </li>

                  <li className="form__submit-wrapper">
                    <input
                      className="btn"
                      type="submit"
                      value="Change Fun Fact"
                    />
                  </li>
                </ul>
              </form>
            </div>
          </div>
        )
      }}
    </Formik>
  )
}

const ChangeFunFactModal = () => {
  return <ChangeFunFactForm />
}

export default ChangeFunFactModal
